import React from "react";
import "./FisheriesStats.scss";
import utils from "../../../../helpers/utils";
import LargeStat from "../../../Stats/LargeStat";

function FisheriesStats(props) {
  const {
    stats,
    selectedGeometry,
    selectedStat,
    handleStatClick,
    layersToInclude,
    layersEnabled,
    handleLayerToggle,
  } = props;
  /**
   * For the current geo selection, get the associated country attr in the stats table
   */
  const country = utils.getCountryAttrForSelectedGeometry(selectedGeometry);

  return (
    <div className="fisheriesStats">
      <div className="large-stat-container">
        {stats
          .filter((i) => i.active)
          .map((item) => (
            <LargeStat
              key={item.id}
              item={item}
              handleStatClick={handleStatClick}
              selectedStat={selectedStat}
              country={country}
              layersToInclude={layersToInclude}
              layersEnabled={layersEnabled}
              handleLayerToggle={handleLayerToggle}
            />
          ))}
      </div>
    </div>
  );
}

export default FisheriesStats;
